/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { WorkflowSystemNameViewModel } from './WorkflowSystemNameViewModel'; 

export function getWorkflowSystemNamesOptions(stayId: string, onSuccess?: (result: WorkflowSystemNameViewModel[]) => void) {
	return queryOptions({
		queryKey: ['workflow-system-names', stayId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/workflows/queries/getworkflowsystemnames/' + stayId;
			const resp = await axios.get<WorkflowSystemNameViewModel[]>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(stayId)
	});
}